import React from 'react';

import styles from '../styles/form.css';

export const SuccessSvg = () => (
    <svg
        className={styles.svgPosition}
        fill="none"
        height="76"
        viewBox="0 0 80 76"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_dd)">
            <path
                clipRule="evenodd"
                d="M60 24C60 35.0458 51.0456 44 40 44C28.9543 44 20 35.0458 20 24C20 12.9543 28.9543 4 40 4C51.0456 4 60 12.9543 60 24ZM37 32L50 19L47 16L37 26L33 22L30 25L37 32Z"
                fill="#2FC26E"
                fillRule="evenodd"
            />
        </g>
        <defs>
            <filter
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
                height="80"
                id="filter0_dd"
                width="80"
                x="0"
                y="-4"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="12" />
                <feGaussianBlur stdDeviation="10" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.184314 0 0 0 0 0.760784 0 0 0 0 0.431373 0 0 0 0.2 0"
                />
                <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.184314 0 0 0 0 0.760784 0 0 0 0 0.431373 0 0 0 0.08 0"
                />
                <feBlend in2="effect1_dropShadow" mode="normal" result="effect2_dropShadow" />
                <feBlend in="SourceGraphic" in2="effect2_dropShadow" mode="normal" result="shape" />
            </filter>
        </defs>
    </svg>
);
